// extracted by mini-css-extract-plugin
module.exports = {"modalSocialButtons":"LoginModal-module__modalSocialButtons___wl4XW","logo":"LoginModal-module__logo___FZ9z+","content":"LoginModal-module__content___u0OJe"};